import {
  BENEFICIAL_OWNER_CITY,
  BENEFICIAL_OWNER_COUNTRY,
  BENEFICIAL_OWNER_DATE_OF_BIRTH,
  BENEFICIAL_OWNER_FIRST_NAME,
  BENEFICIAL_OWNER_MIDDLE_NAME,
  BENEFICIAL_OWNER_LAST_NAME,
  BENEFICIAL_OWNER_NATIONALITY,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PAN_CARD_DOCUMENT,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PASSPORT_DOCUMENT,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PERSON_UTILITY_BILL_DOCUMENT,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON,
  BENEFICIAL_OWNER_SALUTATION,
  BENEFICIAL_OWNER_STATE,
  BENEFICIAL_OWNER_STREET_NAME,
  BENEFICIAL_OWNER_STREET_NUMBER,
  BENEFICIAL_OWNER_UBO_OTHER_REASON,
  BENEFICIAL_OWNER_VOTING_SHARE,
  BENEFICIAL_OWNER_ZIP_CODE,
  BENEFICIAL_OWNER_ADDITIONAL_NATIONALITIES,
  BENEFICIAL_OWNER_COUNTRY_OF_BIRTH,
} from '@modifi/plugin-onboarding'

import {UploadedDocument} from '../../../types/common'

// @Todo move to onboarding package once its safe to merge
const BENEFICIAL_OWNER_VISA_DOCUMENT = 'ultimateBeneficialOwner.visaDocument'

export const BENEFICIAL_OWNER_DOCUMENT_INPUT_FIELD_NAMES: string[] = [
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PASSPORT_DOCUMENT,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PAN_CARD_DOCUMENT,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PERSON_UTILITY_BILL_DOCUMENT,
  BENEFICIAL_OWNER_VISA_DOCUMENT,
]

export const BENEFICIAL_OWNER_PERSON_INPUT_FIELD_NAMES: string[] = [
  BENEFICIAL_OWNER_SALUTATION,
  BENEFICIAL_OWNER_FIRST_NAME,
  BENEFICIAL_OWNER_MIDDLE_NAME,
  BENEFICIAL_OWNER_LAST_NAME,
  BENEFICIAL_OWNER_STREET_NAME,
  BENEFICIAL_OWNER_STREET_NUMBER,
  BENEFICIAL_OWNER_COUNTRY,
  BENEFICIAL_OWNER_CITY,
  BENEFICIAL_OWNER_STATE,
  BENEFICIAL_OWNER_ZIP_CODE,
  BENEFICIAL_OWNER_DATE_OF_BIRTH,
  BENEFICIAL_OWNER_COUNTRY_OF_BIRTH,
  BENEFICIAL_OWNER_NATIONALITY,
  BENEFICIAL_OWNER_ADDITIONAL_NATIONALITIES,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON,
]

export const BENEFICIAL_OWNER_ROLE_INPUT_FIELD_NAMES: string[] = [
  BENEFICIAL_OWNER_VOTING_SHARE,
  BENEFICIAL_OWNER_UBO_OTHER_REASON,
]

export const FIELD_NAME_TO_PROPERTY_NAME_MAPPING: Record<string, string> = {}

export type BeneficialOwnerFormData = {
  [BENEFICIAL_OWNER_CITY]?: string
  [BENEFICIAL_OWNER_COUNTRY]?: string
  [BENEFICIAL_OWNER_DATE_OF_BIRTH]?: string
  [BENEFICIAL_OWNER_FIRST_NAME]?: string
  [BENEFICIAL_OWNER_MIDDLE_NAME]?: string
  [BENEFICIAL_OWNER_LAST_NAME]?: string
  [BENEFICIAL_OWNER_NATIONALITY]?: string
  [BENEFICIAL_OWNER_COUNTRY_OF_BIRTH]?: string
  [BENEFICIAL_OWNER_ADDITIONAL_NATIONALITIES]?: string
  [BENEFICIAL_OWNER_POLITICALLY_EXPOSED]?: boolean
  [BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON]?: string
  [BENEFICIAL_OWNER_SALUTATION]?: string
  [BENEFICIAL_OWNER_STATE]?: string
  [BENEFICIAL_OWNER_STREET_NAME]?: string
  [BENEFICIAL_OWNER_STREET_NUMBER]?: string
  [BENEFICIAL_OWNER_ZIP_CODE]?: string
  [BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PASSPORT_DOCUMENT]?: UploadedDocument[]
  [BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PAN_CARD_DOCUMENT]?: UploadedDocument[]
  [BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PERSON_UTILITY_BILL_DOCUMENT]?: UploadedDocument[]
  [BENEFICIAL_OWNER_VISA_DOCUMENT]?: UploadedDocument[]
}
